import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 add_products_to_goods_received_and_complete_goods_received: { message: "idle" },
};

export const add_products_to_goods_received_and_complete_goods_received_Slice = createSlice({
 name: "add_products_to_goods_received_and_complete_goods_received",
 initialState,
 reducers: {
  success_add_products_to_goods_received_and_complete_goods_received: (state, action) => {
   state.add_products_to_goods_received_and_complete_goods_received = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_add_products_to_goods_received_and_complete_goods_received: (state, action) => {
   state.add_products_to_goods_received_and_complete_goods_received = { status: app_consts.FAIL, message: action.payload };
  },
  reset_add_products_to_goods_received_and_complete_goods_received: (state) => {
   state.add_products_to_goods_received_and_complete_goods_received = { status: app_consts.IDLE };
  },
  loading_add_products_to_goods_received_and_complete_goods_received: (state) => {
   state.add_products_to_goods_received_and_complete_goods_received = { status: app_consts.LOADING };
  },
 }
});

export const { success_add_products_to_goods_received_and_complete_goods_received, fail_add_products_to_goods_received_and_complete_goods_received, reset_add_products_to_goods_received_and_complete_goods_received, loading_add_products_to_goods_received_and_complete_goods_received } = add_products_to_goods_received_and_complete_goods_received_Slice.actions;

export default add_products_to_goods_received_and_complete_goods_received_Slice.reducer;